<template>
	<div class="wrapper">
		<div class="dashboard-container">
			<div class="left-section">
				<p class="text-justify">
					در این بخش میتوانید به دشبورد مانیتوریتگ لاگ ها، بوم نمایش زیرساخت سرویس ها و همچنین فایل
					آخرین لیست دیوایس های فعال در سامانه دسترسی داشته باشید. لطفا موارد زیر را در استفاده از
					این ابزار ها در نظر داشته باشید:
				</p>
				<ul class="bullet-list">
					<li class="bullet-item">
						<span class="bullet-point">•</span>
						<span class="bullet-text"
							>به علت حجم زیاد لاگ ها بازه تاریخی در دشبورد را نهایتا 2 هفته تنظیم کنید.</span
						>
					</li>
					<li class="bullet-item">
						<span class="bullet-point">•</span>
						<span class="bullet-text"
							>در بخش بوم به علت تعداد بالای دستگاه ها تمامی دستگاه ها ست نشدند ولی با smoke test
							میتوانید عملکرد کلی را تست کنید.</span
						>
					</li>

					<li class="bullet-item">
						<span class="bullet-point">•</span>
						<span class="bullet-text"
							>در صورتی که در بوم تغییری ایجاد کنید صرفا به شما نمایش داده می شود و در سامانه خللی
							ایجاد نمی‌کند ولی توصیه می شود ارتباط ها و کانتینر ها را تغییر ندهید تا عملکرد بخش تست
							صحیح کار کند.</span
						>
					</li>
				</ul>
			</div>

			<div class="right-section">
				<img src="@/assets/images/IOT.webp" class="dashboard-image" alt="Dashboard" />
			</div>
		</div>

		<div
			v-if="showLoadingModal"
			class="modal fade show"
			style="display: block"
			tabindex="-1"
			@click="closeLoadingModal"
		>
			<div class="modal-dialog modal-dialog-centered" @click.stop>
				<div class="modal-content">
					<div class="modal-body text-center">
						<img style="object-fit: contain; max-width: 200px;" :src="this.$PATH.GET_IMAGE_PATH('loading.gif')" alt="">
						<h3 class="loading-title">در حال ست کردن توکن</h3>
						<p class="loading-subtitle">لطفا منتظر بمانید</p>
					</div>
				</div>
			</div>
		</div>
		<div v-if="showLoadingModal" class="modal-backdrop fade show" @click="closeLoadingModal"></div>

		<!-- <div
			v-if="showSecondaryModal"
			class="modal fade show"
			style="display: block"
			tabindex="-1"
			@click="closeSecondaryModal"
		>
			<div class="modal-dialog modal-xl modal-dialog-centered" @click.stop>
				<div class="modal-content">
					<div class="modal-body p-0">
						<iframe :src="iframeLink" frameborder="0" class="dashboard-iframe"></iframe>
					</div>
				</div>
			</div>
		</div>
		<div
			v-if="showSecondaryModal"
			class="modal-backdrop fade show"
			@click="closeSecondaryModal"
		></div> -->
		<div class="container">
			<div class="buttons-row">
				<button @click="openPrimaryModal" class="btn btn-primarys">بوم ابزار ها</button>

				<button @click="openSecondaryModal" class="btn btn-secondary">دشبورد مانیتورینگ</button>

				<button @click="downloadFile" class="btn btn-download">دستگاه های فعال</button>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			iframeLink: null,
			showLoadingModal: false,
			showSecondaryModal: false,
		};
	},
	mounted() {
		this.getProjectList();
	},
	methods: {
		async getProjectList() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.MENU_LIST +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId +
					'&is_active=true' +
					'&has_iframe=true' +
					'&frontend_route_url=/dashboard',
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.iframeLink = res.data[0].iframe_link;
			}
		},

		openPrimaryModal() {
			this.showLoadingModal = true;

			setTimeout(() => {
				this.showLoadingModal = false;
				window.open('https://iot.kavoshsystemyar.ir', '_blank');
			}, 4000);
		},

		openSecondaryModal() {
			this.$router.push('/iot/monitoring');
		},

		// closeSecondaryModal() {
		// 	this.showSecondaryModal = false;
		// },

		closeLoadingModal() {
			this.showLoadingModal = false;
		},

		downloadFile() {
			const link = document.createElement('a');
			link.href = 'https://cdn.cloubit.com/kavosh-public/Devices_Data.zip';
			link.download = 'active-devices.pdf';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
	},
};
</script>

<style lang="scss" scoped>
.wrapper {
	margin: 24px;
	background: #fff;
	border-radius: 8px;
	border: 1px solid #dee2e6;
}
.dashboard-container {
	margin: 24px;
	display: flex;
	gap: 30px;
	
}

.left-section {
	flex: 1;
	max-width: 600px;

	.bullet-list {
		list-style: none;
		padding: 0;

		.bullet-item {
			margin-bottom: 15px;
			display: flex;
			align-items: flex-start;

			.bullet-point {
				color: #9b364c;
				font-size: 20px;
				margin-left: 10px;
				margin-top: 2px;
			}

			.bullet-text {
				color: #666;
				line-height: 1.6;
			}
		}
	}
}

.right-section {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
}

.dashboard-image {
	width: 100%;
	max-width: 500px;
	height: auto;
}

.buttons-row {
	display: flex;
	gap: 15px;
	width: 100%;
	padding: 24px;
	justify-content: center;
	border-radius: 8px;
	.btn {
		flex: 1;
		max-width: 200px;
		padding: 15px 20px;
		border: none;
		border-radius: 8px;
		font-size: 16px;
		font-weight: 600;
		cursor: pointer;

		&.btn-primarys {
			background: #9b364c;
			color: white;
		}

		&.btn-secondary {
			background: #fff;
			border: 1px solid #9b364c !important;
			color: #9b364c;
		}

		&.btn-download {
			background: #28a745;
			color: white;
		}
	}
}

.loading-icon {
	font-size: 48px;
	margin-bottom: 20px;
}

.loading-title {
	color: #333;
	margin-bottom: 10px;
}

.loading-subtitle {
	color: #666;
}

.dashboard-iframe {
	width: 100%;
	height: 70vh;
	border: none;
}
</style>
